import { render } from "./moeRight.vue?vue&type=template&id=23b6b0b1&scoped=true"
import script from "./moeRight.vue?vue&type=script&lang=js"
export * from "./moeRight.vue?vue&type=script&lang=js"

import "./moeRight.vue?vue&type=style&index=0&id=23b6b0b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b6b0b1"]])

export default __exports__